import Vue from 'vue';
import Vuex, { ActionContext } from 'vuex';
import User from "@/models/User";
import AfiliadoService from '@/services/AfiliadoService';
import ValidacionCertificacionTss from './models/ValidacionCertificacionTss';
import { eraseCookie, setCookie, serializeValue, getCookie, deserializeValue } from './utils/HelperFunctions';
import IframeCommunicatorService, { InterPagesMessages, MessageTypes } from "@/services/IframeCommunicatorService";
import TipoBeneficioEnum from './enums/TipoBeneficioEnum';
import GlobalConfig from "@/GlobalConfig";
import Benefactor from './models/Sobrevivencia/Benefactor';
import NoLoggedUser from './models/Sobrevivencia/NoLoggedUser/NoLoggedUser';
var iframeService = new IframeCommunicatorService();
var afiliadoService = new AfiliadoService();
//
Vue.use(Vuex);

interface RootState {
    user: User,
    cedulaFallecido: string,
    sessionId: string,
    nombreAfiliadoFallecido: string,
    aplicaTramite: boolean,
    requiereDocumento: boolean,
    displaySideBar:boolean,
    cedulaBeneficiarioNoRegistrado: string,
    validacionCertificacionTss: ValidacionCertificacionTss,
    validateAllSobrevivencia:boolean,
    currentBenefactor:Benefactor,
    noLoggedUser:NoLoggedUser
    
}

export default new Vuex.Store<RootState>({
    state: {
        user: deserializeValue(getCookie("portalBe") || "") as User,
        cedulaFallecido: sessionStorage.getItem("cedulaFallecido") || "",
        sessionId: sessionStorage.getItem("sessionId") || "",
        nombreAfiliadoFallecido: sessionStorage.getItem("nombreAfiliadoFallecido") || "",
        aplicaTramite: Boolean(localStorage.getItem("aplicaTramite")) || false,
        requiereDocumento: Boolean(localStorage.getItem("requiereDocumento")) || true,
        displaySideBar : true,
        cedulaBeneficiarioNoRegistrado: localStorage.getItem("cedulaBeneficiarioNoRegistrado") || "",
        validacionCertificacionTss: (JSON.parse(sessionStorage.getItem("validacionCertificacionTss")) as ValidacionCertificacionTss) || new ValidacionCertificacionTss(),
        validateAllSobrevivencia: Boolean(localStorage.getItem("validateAllSobrevivencia")) || true,
        currentBenefactor: (JSON.parse(sessionStorage.getItem("currentBenefactor")) as Benefactor) || null,
        noLoggedUser: (JSON.parse(sessionStorage.getItem("noLoggedUser")) as NoLoggedUser) || null,
        
        
    },
    mutations: {
        setUserLogged(state, user) {
            state.user = user;
            var serialized = serializeValue(user);
            setCookie("portalBe", serialized);
            setCookie("portalBe_exp", new Date().toUTCString());
            //
            //Esta propiedad es settiada en el main.ts donde se llama al ApplicationInsight COnfig
            Vue.prototype.$appInsight.setUserContext({authenticatedUserId: user.cedula, storeInCookie: true});
        },
        updateUserInfo(state, user) {
            state.user = user;
            var serialized = serializeValue(user);
            setCookie("portalBe", serialized);
        },
		setSessionId(state, sessionId) {
            state.sessionId = sessionId;
            sessionStorage.setItem("sessionId", sessionId);
        },
        setCedulaFallecido(state: RootState, payload: string) {
            state.cedulaFallecido = payload;
            sessionStorage.setItem("cedulaFallecido", payload);
        },
        setNombreAfiliadoFallecido(state: RootState, payload: string) {
            state.nombreAfiliadoFallecido = payload;
            sessionStorage.setItem("nombreAfiliadoFallecido", payload);
        },
        setAplicaTramite(state: RootState, payload: boolean) {
            state.aplicaTramite = payload;
            localStorage.setItem("aplicaTramite", payload.toString());
        },
        setRequiereDocumento(state: RootState, payload: boolean) {
            state.requiereDocumento = payload;
            localStorage.setItem("requiereDocumento", payload.toString());
        },
        logOutUser(state: RootState) {
            state.user = null;
			state.sessionId = null;
            eraseCookie("portalBe_exp");
            eraseCookie("portalBe");
            eraseCookie("noAfiliadoName");
            iframeService.postMessageToParent(
                new InterPagesMessages(MessageTypes.LogOut,"")
            );
            //Esta propiedad es settiada en el main.ts donde se llama al ApplicationInsight COnfig
            Vue.prototype.$appInsight.clearUserContext();
        },
        setCedulaBeneficiarioNoRegistrado(state: RootState, payload: string) {
            state.cedulaBeneficiarioNoRegistrado = payload;
            localStorage.setItem("cedulaBeneficiarioNoRegistrado", payload);
        },
        setValidacionCertificacionTss(state: RootState, payload: ValidacionCertificacionTss) {
            state.validacionCertificacionTss = payload;
            sessionStorage.setItem("validacionCertificacionTss", JSON.stringify(payload));
        },
        SetDisplaySideBar(state: RootState, payload: boolean) {
            state.displaySideBar = payload;
            sessionStorage.setItem("displaySideBar", payload.toString());
        },
        setValidateAllSobrevivencia(state: RootState, payload: boolean) {
            state.validateAllSobrevivencia = payload;
            localStorage.setItem("validateAllSobrevivencia", payload.toString());
        },
        setCurrentBenefactor(state: RootState, payload: Benefactor) {
            state.currentBenefactor = payload;
            localStorage.setItem("currentBenefactor", payload.toString());
        },
        setNoLoggedUser(state: RootState, payload: NoLoggedUser) {
            state.noLoggedUser = payload;
            localStorage.setItem("noLoggedUser", payload.toString());
        },
    },
    actions: {
        setCedulaFallecidoAction(context: ActionContext<RootState, RootState>, payload: string) {
            context.commit('setCedulaFallecido', payload);
        },
        setNombreAfiliadoFallecidoAction(context: ActionContext<RootState, RootState>, payload: string) {
            context.commit('setNombreAfiliadoFallecido', payload);
        },
        setUserLoggedAction(context: ActionContext<RootState, RootState>, user: User) {
            context.commit('setUserLogged', user);
        },
        setAplicaTramiteAction(context: ActionContext<RootState, RootState>, payload: boolean) {
            context.commit('setAplicaTramite', payload);
        },
        setRequiereDocumentoAction(context: ActionContext<RootState, RootState>, payload: boolean) {
            context.commit('setRequiereDocumento', payload);
        },
		setSessionId(context: ActionContext<RootState, RootState>, payload: string) {
            context.commit('setSessionId', payload);
        },
        logOut(context: any) {
            afiliadoService.logOut(this.state.sessionId);
            context.commit('logOutUser');
        },
        setCedulaBeneficiarioNoRegistradoAction(context: ActionContext<RootState, RootState>, payload: boolean) {
            context.commit('setCedulaBeneficiarioNoRegistrado', payload);
        },
        setValidacionCertificacionTssAction(context: ActionContext<RootState, RootState>, payload: ValidacionCertificacionTss) {
            context.commit('setValidacionCertificacionTss', payload);
        },
        updateUserInfo(context: ActionContext<RootState, RootState>, payload: User) {
            context.commit("updateUserInfo", payload);
        },
        sendToEncuesta(context: ActionContext<RootState, RootState>, payload: {numeroSolicitud: number, tipoBeneficio: TipoBeneficioEnum}) {
            setTimeout(() => {
                let url = `/encuesta?numeroPresolicitud=${payload.numeroSolicitud}&tipoBeneficio=${payload.tipoBeneficio}`;
                
                if (GlobalConfig.ENVIRONMENT != "dev") {
                    //if we are under and iframe
                    iframeService
                        .postMessageToParent(new InterPagesMessages(MessageTypes.OpenTab, url));
                } else {
                    window.open(url, '_blank');
                }
            }, 1000);
        },
        SetDisplaySideBarAction(context: ActionContext<RootState, RootState>, payload: boolean){
            context.commit('SetDisplaySideBar', payload);
        },
        setValidateAllSobrevivenciaAction(context: ActionContext<RootState, RootState>, payload: boolean) {
            context.commit('setValidateAllSobrevivencia', payload);
        },
        setCurrentBenefactor(context: ActionContext<RootState, RootState>, payload: Benefactor) {
            context.commit('setCurrentBenefactor', payload);
        },
        setNoLoggedUser(context: ActionContext<RootState, RootState>, payload: NoLoggedUser) {
            context.commit('setNoLoggedUser', payload);
        },
    },
    getters: {
        isLoggedIn: state => !!state.user,
        cedulaFallecido(state: RootState): string {
            return state.cedulaFallecido;
        },
        nombreAfiliadoFallecido(state: RootState): string {
            return state.nombreAfiliadoFallecido;
        },
        user: (state: RootState): User => {
            const userModel: User = state.user;
            const instancedUserModel = new User();
            for (const key in userModel) {
                if (Object.prototype.hasOwnProperty.call(userModel, key)) {
                    instancedUserModel[key] = userModel[key];
                }
            }
            return instancedUserModel;
        },
		sessionID (state: RootState): string {
			return state.sessionId;
		},
        aplicaTramite(state: RootState): boolean {
            return state.aplicaTramite;
        },
        requiereDocumento(state: RootState): boolean {
            return state.requiereDocumento;
        },
        cedulaBeneficiarioNoRegistrado(state: RootState): string {
            return state.cedulaBeneficiarioNoRegistrado;
        },
        validacionCertificacionTss(state: RootState): ValidacionCertificacionTss {
            return state.validacionCertificacionTss;
        },
        displaySideBar(state: RootState): boolean {
            return state.displaySideBar;
        },
        validateAllSobrevivencia(state: RootState): boolean {
            return state.validateAllSobrevivencia;
        },
        currentBenefactor(state: RootState): Benefactor {
            return state.currentBenefactor;
        },
        noLoggedUser(state: RootState): NoLoggedUser {
            return state.noLoggedUser;
        },
    }
});